import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Header from "../../components/Header";

class SaqWizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      que1: "",
      que2: "",
      que21: "",
      que22: "",
      que23: "",
      que3: "",
      que31: "",
      que32: "",
      que4: "",
      keyCheckbox: Math.random(),
    };
  }

  handleChange(e) {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
      keyCheckbox: Math.random(),
    });
  }

  render() {
    return (
      <div className="cell small-12 medium-10" id="maincontent">
        <Header />
        <div id="body-content">
          <div className="grid-x grid-margin-x grid-margin-y">
            <div className="cell small-12 medium-12" id="completedsaqs">
              <h3>SAQ Wizard</h3>
              <br />

              <div id="compltedsaqs-table">
                <div class="grid-x grid-padding-x">
                  <fieldSet class="large-12 cell">
                    <legend>Are you an Ecommerce Business?</legend>
                    <input
                      type="radio"
                      name="que1"
                      value="yes"
                      id="que1Yes"
                      checked={this.state.que1 === "yes"}
                      onChange={this.handleChange.bind(this)}
                    />
                    <label htmlFor="que1Yes">Yes</label>
                    <input
                      type="radio"
                      name="que1"
                      value="no"
                      id="que1No"
                      checked={this.state.que1 === "no"}
                      onChange={this.handleChange.bind(this)}
                    />
                    <label htmlFor="que1No">No</label>
                  </fieldSet>
                </div>

                {this.state.que1 === "no" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <fieldSet class="large-12 cell">
                      <legend>
                        Do you electronically save cardholder information ?
                      </legend>
                      <input
                        type="radio"
                        name="que2"
                        value="yes"
                        id="que2Yes"
                        checked={this.state.que2 === "yes"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que2Yes">Yes</label>
                      <input
                        type="radio"
                        name="que2"
                        value="no"
                        id="que2No"
                        checked={this.state.que2 === "no"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que2No">No</label>
                    </fieldSet>
                  </div>
                )}

                {this.state.que2 === "no" && (
                  <>
                    <div
                      class="grid-x grid-padding-x"
                      style={{ marginTop: "15px" }}
                    >
                      <fieldSet class="large-12 cell">
                        <legend>
                          Is all information collected via standalone terminals
                          or imprint-only machines?
                        </legend>
                        <input
                          type="radio"
                          name="que21"
                          value="yes"
                          id="que21Yes"
                          checked={this.state.que21 === "yes"}
                          onChange={this.handleChange.bind(this)}
                        />
                        <label htmlFor="que21Yes">Yes</label>
                        <input
                          type="radio"
                          name="que21"
                          value="no"
                          id="que21No"
                          checked={this.state.que21 === "no"}
                          onChange={this.handleChange.bind(this)}
                        />
                        <label htmlFor="que21No">No</label>
                      </fieldSet>
                    </div>
                  </>
                )}

                {this.state.que21 === "yes" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <div
                      className="callout primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/create/saq-b");
                      }}
                    >
                      It looks like The <b>SAQ B</b> would be best for you.
                      Click Here to start it now.
                    </div>
                  </div>
                )}

                {this.state.que21 === "no" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <fieldSet class="large-12 cell">
                      <legend>
                        Is all information collected via standalone PTS-approved
                        point-of-interaction (POI) devices with an IP connection
                        to the payment processor (this is common for brick and
                        mortar businesses)?
                      </legend>
                      <input
                        type="radio"
                        name="que22"
                        value="yes"
                        id="que22Yes"
                        checked={this.state.que22 === "yes"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que22Yes">Yes</label>
                      <input
                        type="radio"
                        name="que22"
                        value="no"
                        id="que22No"
                        checked={this.state.que22 === "no"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que22No">No</label>
                    </fieldSet>
                  </div>
                )}

                {this.state.que22 === "yes" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <div
                      className="callout primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/create/saq-b-ip");
                      }}
                    >
                      It looks like The <b>SAQ B-IP</b> would be best for you.
                      Click Here to start it now.
                    </div>
                  </div>
                )}

                {this.state.que22 === "no" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <fieldSet class="large-12 cell">
                      <legend>
                        Do you collect payments via phone and/or web-hosted
                        payment entry?
                      </legend>
                      <input
                        type="radio"
                        name="que23"
                        value="yes"
                        id="que23Yes"
                        checked={this.state.que23 === "yes"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que23Yes">Yes</label>
                      <input
                        type="radio"
                        name="que23"
                        value="no"
                        id="que23No"
                        checked={this.state.que23 === "no"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que23No">No</label>
                    </fieldSet>
                  </div>
                )}

                {this.state.que23 === "yes" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <div
                      className="callout primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/create/saq-c");
                      }}
                    >
                      It looks like The <b>SAQ C</b> would be best for you.
                      Click Here to start it now.
                    </div>
                  </div>
                )}

                {this.state.que1 === "yes" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <fieldSet class="large-12 cell">
                      <legend>
                        When collecting credit card data are you able to
                        programatically view the data at anytime?
                      </legend>
                      <input
                        type="radio"
                        name="que3"
                        value="yes"
                        id="que3Yes"
                        checked={this.state.que3 === "yes"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que3Yes">Yes</label>
                      <input
                        type="radio"
                        name="que3"
                        value="no"
                        id="que3No"
                        checked={this.state.que3 === "no"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que3No">No</label>
                    </fieldSet>
                  </div>
                )}

                {this.state.que3 === "yes" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <fieldSet class="large-12 cell">
                      <legend>
                        Do you electronically save any cardholder information?
                      </legend>
                      <input
                        type="radio"
                        name="que31"
                        value="yes"
                        id="que31Yes"
                        checked={this.state.que31 === "yes"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que31Yes">Yes</label>
                      <input
                        type="radio"
                        name="que31"
                        value="no"
                        id="que31No"
                        checked={this.state.que31 === "no"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que31No">No</label>
                    </fieldSet>
                  </div>
                )}

                {this.state.que3 === "no" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <div
                      className="callout primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/create/saq-a");
                      }}
                    >
                      It looks like The <b>SAQ A</b> would be best for you.
                      Click Here to start it now.
                    </div>
                  </div>
                )}

                {this.state.que31 === "no" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <fieldSet class="large-12 cell">
                      <legend>
                        Is the information collected to sent straight to the
                        payment processor?
                      </legend>
                      <input
                        type="radio"
                        name="que32"
                        value="yes"
                        id="que32Yes"
                        checked={this.state.que32 === "yes"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que32Yes">Yes</label>
                      <input
                        type="radio"
                        name="que32"
                        value="no"
                        id="que32No"
                        checked={this.state.que32 === "no"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que32No">No</label>
                    </fieldSet>
                  </div>
                )}

                {this.state.que32 === "yes" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <div
                      className="callout primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/create/saq-a-ep");
                      }}
                    >
                      It looks like The <b>SAQ A-EP</b> would be best for you.
                      Click Here to start it now.
                    </div>
                  </div>
                )}

                {(this.state.que2 === "yes" ||
                  this.state.que32 === "no" ||
                  this.state.que31 === "yes" ||
                  this.state.que23 === "no") && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <fieldSet class="large-12 cell">
                      <legend>
                        Are you a service provider (A service provider is
                        defined as a Business entity that is not a payment
                        brand, directly involved in the processing, storage, or
                        transmission of cardholder data. This also includes
                        companies that provide services that control or could
                        impact the security of cardholder data.)
                      </legend>
                      <input
                        type="radio"
                        name="que4"
                        value="yes"
                        id="que4Yes"
                        checked={this.state.que4 === "yes"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que4Yes">Yes</label>
                      <input
                        type="radio"
                        name="que4"
                        value="no"
                        id="que4No"
                        checked={this.state.que4 === "no"}
                        onChange={this.handleChange.bind(this)}
                      />
                      <label htmlFor="que4No">No</label>
                    </fieldSet>
                  </div>
                )}

                {this.state.que4 === "no" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <div
                      className="callout primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/create/saq-d-me");
                      }}
                    >
                      It looks like The <b>SAQ D-ME</b> would be best for you.
                      Click Here to start it now.
                    </div>
                  </div>
                )}

                {this.state.que4 === "yes" && (
                  <div
                    class="grid-x grid-padding-x"
                    style={{ marginTop: "15px" }}
                  >
                    <div
                      className="callout primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/create/saq-d-sp");
                      }}
                    >
                      It looks like The <b>SAQ D-SP</b> would be best for you.
                      Click Here to start it now.
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SaqWizard);
